import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'

// evertel
import { Col, Row } from '@evertel/web/ui'
import { ThreadContext } from '../Thread'
import { useService } from '@evertel/di'
import { ProfilePic } from '@evertel/web/user'
import { SessionService } from '@evertel/session/SessionService'


const ThreadHeader = observer(() => {

    const { threadController } = useContext(ThreadContext)
    const sessionService = useService(SessionService, [])

    const isOneUser = threadController.isJustMe || threadController.usersNotMe?.length === 1
    const user = (threadController.isJustMe) ? threadController.users.find(u => u.id === sessionService.currentUserId) : threadController.usersNotMe[0]

    return (
        <Row className="page-toolbar">
            <Col xs={10}>
                <div className="flex-row align-items-center">
                    {(isOneUser && user) ?
                        <ProfilePic
                            userId={user.id}
                            height={35}
                            width={35}
                        />
                        :
                        <div
                            className="h4 mb-0">
                            <span className="badge text-bg-gray fw-bolder d-flex align-items-center justify-content-center"
                                style={{width: 35, height: 35}}
                            >{threadController.users?.length - 1}</span>
                        </div>
                    }
                    <div className={classNames('position-relative overflow-auto m-0 ms-2')}>
                        <PerfectScrollbar>
                            <span className="h4 mb-0 fw-bolder text-nowrap">{threadController?.name || 'No Name'}</span>
                        </PerfectScrollbar>
                    </div>
                </div>
            </Col>
            <Col align="right">

            </Col>
        </Row>
    )
})

export { ThreadHeader }
